module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_patch_4.8230cb0f.svg";